import React from "react";
import { useParams } from "react-router-dom";
import FooterOne from "../common/footer/FooterOne";
import HeaderOne from "../common/header/HeaderOne";
import BcrumbBannerOne from "../elements/breadcrumb/BcrumbBannerOne";
import CtaLayoutOne from "../component/cta/CtaLayoutOne";
import SectionTitle from "../elements/section-title/SectionTitle";
import ProjectPropOne from "../component/project/itemProp/ProjectPropOne";
import { slugify } from "../utils";
import ServiceData from "../data/service/ServiceMain.json";
import ProjectData from "../data/project/ProjectData.json";
import AboutTwo from "../component/about/AboutTwo";
import ColorSwitcher from "../elements/switcher/ColorSwitcher";
import SEO from "../common/SEO";
import Tilty from "react-tilty";
import CounterUpTwo from "../component/counterup/CounterUpTwo";
import AboutThree from "../component/about/AboutThree";
import ClientOne from "../component/client/ClientOne";
import BcrumbBannerTwo from "../elements/breadcrumb/BcrumbBannerTwo";

const allServiceData = ServiceData;
const getProjectData = ProjectData;

const CafmSoftware = () => {
  // const params = useParams();
  // const serviceSlug = params.slug;

  // const getServiceData = allServiceData.filter(data => slugify(data.title) === serviceSlug);
  const detailsService = ServiceData[0];

  return (
    <>
      <SEO title="Service Details" />
      {/* <ColorSwitcher /> */}
      <main className="main-wrapper">
        <HeaderOne />
        <BcrumbBannerTwo
          title="Computer-Aided Facility Management"
          paragraph="Facility managers can optimise and streamline a wide range of operational processes with the help of computer-aided facility management (CAFM) software. Software for CAFM allows for efficient planning, execution, and monitoring of critical activities by integrating technology into facility management. These include operational facility services, space and move management, asset management, reactive and planned preventative maintenance, and customer services."
          styleClass=""
          S
          mainThumb="/images/banner/mission-vision.jpg"
          // mainThumb="/images/banner/industry-img.jpg"
        />
        <div className="container space" style={{ maxWidth: "800px" }}>
          <h5 style={{ textAlign: "center" }}>Maintenance Management</h5>
          <p>
            Whether it's reactive or planned preventative maintenance, CAFM
            software makes scheduling and tracking it all easier. It automates
            maintenance schedules, tracks work orders, and enables real-time
            updates to ensure facilities operate efficiently. Task
            prioritisation, downtime reduction, and critical asset lifespan
            extension are all within the purview of facility managers.
          </p>
          <h5 style={{ textAlign: "center" }}>Space and Move Management</h5>
          <p>
          Space efficiency is of the utmost importance in contemporary buildings. Efficient space allocation can be planned and managed with the help of CAFM software. With the insights provided by CAFM systems, more imaginative space utilisation is made possible. No matter if the goal is to improve office layouts, handle employee moves, or make room for the company to grow.
          </p>
          <h5 style={{ textAlign: "center" }}>Asset Management</h5>
          <p>
          Particularly in expansive establishments, asset management presents several challenges. CAFM software helps keep tabs on asset lifespans, performance, and warranties. Repair, replacement, or upgrade decisions can be made by facility managers using data. It improves operational efficiency and reduces costs.
          </p>
          <h5 style={{ textAlign: "center" }}>Operational Facility Services</h5>
          <p>
          CAFM software coordinates and delivers cleaning, security, catering, and waste management. As a result, the building's occupants and visitors will have a better experience overall.
          </p>
          <h5 style={{ textAlign: "center" }}>Customer Service and Ticket Management</h5>
          <p>
          Among CAFM software's many noteworthy features is its capacity to join requests for customer service. Users can report issues, track progress, and receive timely updates through a simplified ticketing system. Accountability is guaranteed, and transparency is enhanced.
          </p>
          <h5 style={{ textAlign: "center" }}>Environmental and Energy Efficiency</h5>
          <p>
          The ability to track and lower energy usage is common in modern CAFM software. Facility managers can reduce costs and minimise environmental impact by analysing utility usage and identifying inefficiencies. Then, they can install sustainable practices
          </p>
          <h5 style={{ textAlign: "center" }}>Reporting and Compliance</h5>
          <p>
          Facility managers must adhere to all regulations. CAFM systems ensure industry standards by automating compliance monitoring and providing detailed reports. Facility managers can customise audit, maintenance history, and operational summary reports.
          </p>
          <h5 style={{ textAlign: "center" }}>UCWF's Advanced CAFM Solution</h5>
          <p>
          UCWF offers cutting-edge CAFM software that is known for being flexible and easy to use. It's a platform for managing facilities that can be tailored to the needs of clients in a wide range of industries.
          </p>
          <p>
          Ticket tracking and reporting capabilities are a significant strength of UCWF's CAFM software. Clients can easily create and track service requests, ensuring that no issue remains unresolved. The system's real-time updates and detailed reports let customers know exactly how their buildings are doing. This degree of openness promotes confidence and allows for more informed decision-making.
          </p>
          <p>
          In addition to meeting operational needs, UCWF's CAFM software integrates and customises workflows. With powerful analytics and reporting features, facility managers can better optimise performance, spot trends, and increase overall efficiency.
          </p>
          <p>
          CAFM software has become an essential tool for contemporary facility managers. How facilities are managed is revolutionised by its ability to streamline operations, improve resource allocation, and enhance customer satisfaction. Upgrade these capabilities with UCWF's state-of-the-art CAFM software, including ticket tracking and detailed reporting features. If you're in charge of a single building or a large portfolio, you can count on UCWF's CAFM software to help you achieve operational excellence.
          </p>
         
        </div>

        <CounterUpTwo />
        <AboutThree />
        <CtaLayoutOne />
        <FooterOne parentClass="" />
      </main>
    </>
  );
};

export default CafmSoftware;
